// frontend/src/components/Onboarding.jsx
import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import contentService from '../services/contentService';
import './Onboarding.css';

const Onboarding = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const codigoUrl = searchParams.get('codigo');


  const [opcion, setOpcion] = useState(codigoUrl ? 'invitacion' : null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Estados para crear cuenta
  const [nombreCuenta, setNombreCuenta] = useState('');
  const [nombreCliente, setNombreCliente] = useState('');
  const [nombreEmpresa, setNombreEmpresa] = useState('');

  // Estados para invitación
  const [codigo, setCodigo] = useState(codigoUrl || '');

  const handleCrearCuenta = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await contentService.crearCuentaOnboarding({
        nombre_cuenta: nombreCuenta,
        nombre_cliente: nombreCliente,
        nombre_empresa: nombreEmpresa
      });

      if (response.data.success) {
        setSuccess(response.data.message);

        setTimeout(() => {
          navigate('/dashboard');
          window.location.reload();
        }, 2000);
      }
    } catch (err) {
      console.error('Error creando cuenta:', err);
      setError(err.response?.data?.error || 'Error al crear la cuenta');
    } finally {
      setLoading(false);
    }
  };

  const handleUnirseConInvitacion = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await contentService.unirseConInvitacion({
        codigo: codigo.trim()
      });

      if (response.data.success) {
        setSuccess(response.data.message);

        setTimeout(() => {
          navigate('/dashboard');
          window.location.reload();
        }, 2000);
      }
    } catch (err) {
      console.error('Error uniéndose con invitación:', err);
      setError(err.response?.data?.error || 'Error al procesar la invitación');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="onboarding-container">
      <div className="onboarding-card">
        <div className="onboarding-header">
          <h1>🎉 ¡Bienvenido!</h1>
          <p>Para continuar, necesitas configurar tu cuenta</p>
        </div>

        {!opcion && (
          <div className="opciones-container">
            <button
              className="opcion-btn crear-btn"
              onClick={() => setOpcion('crear')}
            >
              <div className="opcion-icon">🏢</div>
              <h3>Crear Nueva Cuenta</h3>
              <p>Empieza tu propia organización</p>
            </button>

            <button
              className="opcion-btn unirse-btn"
              onClick={() => setOpcion('invitacion')}
            >
              <div className="opcion-icon">✉️</div>
              <h3>Unirme con Invitación</h3>
              <p>Tengo un código de invitación</p>
            </button>
          </div>
        )}

        {opcion === 'crear' && (
          <div className="form-container">
            <button
              className="btn-back"
              onClick={() => setOpcion(null)}
            >
              ← Volver
            </button>

            <h2>Crear Nueva Cuenta</h2>

            <form onSubmit={handleCrearCuenta}>
              <div className="form-group">
                <label htmlFor="nombreCuenta">
                  Nombre de la Cuenta <span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="nombreCuenta"
                  value={nombreCuenta}
                  onChange={(e) => setNombreCuenta(e.target.value)}
                  placeholder="Mi Empresa"
                  required
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="nombreCliente">
                  Nombre del Cliente (Opcional)
                </label>
                <input
                  type="text"
                  id="nombreCliente"
                  value={nombreCliente}
                  onChange={(e) => setNombreCliente(e.target.value)}
                  placeholder="Cliente Principal"
                  disabled={loading}
                />
                <small>El cliente principal de tu cuenta</small>
              </div>

              <div className="form-group">
                <label htmlFor="nombreEmpresa">
                  Nombre de la Empresa (Opcional)
                </label>
                <input
                  type="text"
                  id="nombreEmpresa"
                  value={nombreEmpresa}
                  onChange={(e) => setNombreEmpresa(e.target.value)}
                  placeholder="Tu Empresa"
                  disabled={loading}
                />
              </div>

              {error && (
                <div className="alert alert-error">
                  ❌ {error}
                </div>
              )}

              {success && (
                <div className="alert alert-success">
                  ✅ {success}
                </div>
              )}

              <button
                type="submit"
                className="btn-submit"
                disabled={loading || !nombreCuenta.trim()}
              >
                {loading ? 'Creando...' : 'Crear Cuenta'}
              </button>
            </form>
          </div>
        )}

        {opcion === 'invitacion' && (
          <div className="form-container">
            <button
              className="btn-back"
              onClick={() => {
                setOpcion(null);
                setCodigo('');
              }}
            >
              ← Volver
            </button>

            <h2>Unirse con Invitación</h2>

            <form onSubmit={handleUnirseConInvitacion}>
              <div className="form-group">
                <label htmlFor="codigo">
                  Código de Invitación <span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="codigo"
                  value={codigo}
                  onChange={(e) => setCodigo(e.target.value)}
                  placeholder="Ingresa el código recibido"
                  required
                  disabled={loading}
                />
                <small>El código fue enviado a tu email</small>
              </div>

              {error && (
                <div className="alert alert-error">
                  ❌ {error}
                </div>
              )}

              {success && (
                <div className="alert alert-success">
                  ✅ {success}
                </div>
              )}

              <button
                type="submit"
                className="btn-submit"
                disabled={loading || !codigo.trim()}
              >
                {loading ? 'Verificando...' : 'Unirse a la Cuenta'}
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default Onboarding;